/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Basic
 * 
 * 2 = Supervisor
 * 
 * 3 = Admin
 * 
 * 4 = SuperAdmin
 * 
 * 5 = ElevatedAdmin
 */
export enum Roles {
  Basic = 1,
  Supervisor = 2,
  Admin = 3,
  SuperAdmin = 4,
  ElevatedAdmin = 5
}
